import axios from 'axios'
import { ListResponse, ResponseArray, Response } from '../../../../../setup/axios/HttpResponse';
import { HousingResponse, GetZoneRequest, ZoneListResponse, CreateZoneRequest, UpdateZoneStatusRequest, UpdateZoneRequest, ProvinceSearchRequest, ProvinceSearchResponse, GetZoneCondition } from '../models';
import { API_URL } from '../../../../utils/common/constants'

const zoneApi = {
  getZone(body: GetZoneRequest): Promise<ListResponse<ZoneListResponse>> {
    const url = `${API_URL}/api/v1/zones/paging`
    return axios.post(url, body)
  },
  
  getProvince(body: ProvinceSearchRequest): Promise<Response<ProvinceSearchResponse>> {
    const url = `${API_URL}/api/v1/provine/search`
    return axios.post(url, body)
  },
  
  getHousing(provinceIds: number[]): Promise<ResponseArray<HousingResponse>> {
    const url = `${API_URL}/api/v1/housing/get-by-provinces`
    return axios.post(url, provinceIds)
  },

  createZone(body: CreateZoneRequest): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/zones`
    return axios.post(url, body)
  },

  updateStatusZone(zoneId: number, body: UpdateZoneStatusRequest): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/zones/${zoneId}/status`
    return axios.put(url, body)
  },

  getZoneById(zoneId: number, condition: GetZoneCondition): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/zones/${zoneId}`
    return axios.post(url, condition)
  },

  updateZone(zoneId: number, body: UpdateZoneRequest): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/zones/${zoneId}`
    return axios.put(url, body)
  },

  getDispatchActiveByZoneId(zoneId: number): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/zones/get-dispatch-active-by-zone-id/${zoneId}`
    return axios.get(url)
  },
  downloadZoneTemplate(): Promise<Blob> {
    const url = `${API_URL}/api/v1/zones/download-zone-template`;
    return axios.get(url, { responseType: 'blob' });
  },

  importZonesFromExcel(file: File): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/zones/import-zones-from-excel`;
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
}

export default zoneApi
